<button
  mat-icon-button
  [matTooltip]="'igo.geo.directions.buttons.resetStops' | translate"
  color="warn"
  (click)="resetStops()"
>
  <mat-icon>restart_alt</mat-icon>
</button>
<button
  mat-icon-button
  [matTooltip]="'igo.geo.directions.buttons.zoomOnRoute' | translate"
  color="primary"
  (click)="zoomOnActiveRoute.emit()"
>
  <mat-icon>frame_inspect</mat-icon>
</button>
<button
  mat-icon-button
  [matTooltip]="'igo.geo.directions.buttons.copyDirections' | translate"
  color="primary"
  (click)="copyDirectionsToClipboard()"
>
  <mat-icon>content_copy</mat-icon>
</button>
<button
  mat-icon-button
  [matTooltip]="'igo.geo.directions.buttons.copyLink' | translate"
  color="primary"
  (click)="copyLinkToClipboard()"
>
  <mat-icon>link</mat-icon>
</button>

<button
  mat-icon-button
  [disabled]="downloadDirectionsBtnDisabled"
  [matTooltip]="'igo.geo.directions.buttons.downloadDirections' | translate"
  color="primary"
  (click)="downloadDirections()"
>
  <mat-icon>download</mat-icon>
</button>
